<template>
    <div class="max pcenter color-light bg-pos-2 bg-size-cover auto-scroll" :style="`backgroundImage: url(${bg.bgImg})`">

        <!--header-->
        <sec-header-widget v-bind="header_data" />

        <!--本数据包用于如下分析与应用场景-->
        <section id="sec1" class="pad-h-2 mrg-v-2">
            <div class="rel container pad-h-1 pad-v-4 ">

                <!--遮罩-->
                <matteWidget v-bind="bg" />

                <h3 class="rel mrg-b-3 mrg-b-1-s">
                    <span class="fsize-1d5 fsize-d8-s">本数据包用于如下分析与应用场景</span>
                </h3>
                <article class="rel container fsize-1d3 pad-t-2 pjustify fsize-1d2-s pad-h-1-s" md>
                    <list-widget :text-list="introduce" />
                </article>
            </div>
        </section>

        <!--使用人口数据包的客户-->
        <section>
            <sec-customer-widget />
        </section>

        <!--数据包亮点-->
        <section id="sec2" class="container rel pad-v-4 pad-h-2 mrg-v-2 mrg-v-0-s pad-h-1-s">

            <!--遮罩-->
            <matteWidget v-bind="bg" />

            <h2 class="rel mrg-b-3 mrg-b-1-s"><span class="fsize-1d5 fsize-1-s">数据包亮点</span></h2>
            <article class="rel container fsize-1d3 pad-t-2 pjustify fsize-1d2-s" md>
                <table-widget v-bind="data_character" />
            </article>
        </section>

        <!--数据内容-->
        <section id="sec3" class="container rel pad-v-4 pad-h-1 mrg-v-2 mrg-v-0-s">

            <!--遮罩-->
            <matteWidget />

            <h3 class="rel mrg-b-3 mrg-b-1-s">
                <span class="fsize-1d5 fsize-1-s">数据内容</span>
            </h3>
            <div class="rel container fsize-1d2 pad-t-2 pjustify" md>
                <tab-widget v-model="data_cont.val" :tags-data="data_cont.tagsData">
                    <article v-for="(tag,i) of data_cont.tagsData.tagList" :key="i" :slot="tag.id"
                             class="rel bg-color-dgray pad-2 round-sm">
                        <div class="alpha-d6 mrg-b-2 fsize-d9">{{tag.desc}}</div>
                        <ul v-if="tag.text_list" class="grid">
                            <li v-for="(text,i) of tag.text_list" :key="i"
                                class="col-6 line-b thick-1 line-neutral pad-b-d5 mrg-b-d5">
                                <b :class="`mrg-r-1 color-${i%2? 'green': 'yellow'}`">·</b>{{text}}
                            </li>
                        </ul>
                        <slider-widget v-if="tag.slider_data" v-bind="tag.slider_data">
                            <img v-for="page of tag.slider_data.pages" :key="page.id" :slot="page.id"
                                 :src="page.src" />
                        </slider-widget>
                    </article>
                </tab-widget>
            </div>
        </section>

        <!--数据应用领域-->
        <section id="sec4">
            <sec-data-apply-widget :bg-color="bg.bgColor" />
        </section>

        <!--获取数据包-->
        <section id="sec5">
            <sec-data-package-widget :matte-data="bg" />
        </section>

        <!--footer-->
        <sec-footer-widget v-bind="footer_data" />
    </div>
</template>

<script>
    import TableWidget from "@/components/BTXUI/table/table-widget"
    import TabWidget from "@/components/BTXUI/tab/tab-widget"
    import SliderWidget from "@/components/BTXUI/slider/slider-widget"
    import ListWidget from "@/components/list-widget"
    import matteWidget from "@/components/matte-widget"
    import SecHeaderWidget from "@/components/sec-header-widget"
    import SecCustomerWidget from "@/components/sec-customer-widget"
    import SecDataPackageWidget from "@/components/sec-data-package-widget"
    import SecDataApplyWidget from "@/components/sec-data-apply-widget"
    import SecFooterWidget from "@/components/sec-footer-widget"

    const name = "cbd";

    export default {
        name,
        components: {
            TableWidget,
            TabWidget,
            SliderWidget,
            ListWidget,
            matteWidget,
            SecHeaderWidget,
            SecCustomerWidget,
            SecDataPackageWidget,
            SecDataApplyWidget,
            SecFooterWidget
        },
        data(){
            const bg = {
                bgImg: require(`@/assets/img/daas_case/${name}_bg.jpg`),
                bgColor: "dblue"
            }

            return {

                //背景
                bg,

                //头部信息
                header_data: {
                    packageId: name,
                    mainNavData: {
                        logo: require('@/assets/img/logo/logo.png'),
                        navs: [
                            {
                                text: "首页",
                                link: "/"
                            },
                            {
                                text: "本数据解决的问题",
                                link: {
                                    chapter_id: "sec1",
                                    chapter_link_data: {
                                        offset: -60
                                    }
                                }
                            },
                            {
                                text: "数据亮点",
                                link: {
                                    chapter_id: "sec2",
                                    chapter_link_data: {
                                        offset: -60
                                    }
                                }
                            },
                            {
                                text: "数据包内容",
                                link: {
                                    chapter_id: "sec3",
                                    chapter_link_data: {
                                        offset: -60
                                    }
                                }
                            },
                            {
                                text: "数据应用领域",
                                link: {
                                    chapter_id: "sec4",
                                    chapter_link_data: {
                                        offset: -60
                                    }
                                }
                            },
                            {
                                text: "获取数据包",
                                link: {
                                    chapter_id: "sec5",
                                    chapter_link_data: {
                                        offset: -60
                                    }
                                }
                            }
                        ]
                    }
                },

                //概述
                introduce: [
                    "商圈周边配套（吃住行游娱乐购）的完备程度与配套水平评估",
                    "商圈周边人口分布、人口流动、交通拥堵程度测算",
                    "商圈周边商业体、楼宇、商品房的租金/售价分析与价值评估",
                    "商圈的消费水平、消费者口碑等用户体验指标的量化测算",
                    "商圈人群的年龄结构分析",
                    "商圈人群的购物与消费爱好类型分析",
                    "多个商圈的对比分析与竞争分析",
                    "...等与商圈画像与评测相关的场景"
                ],

                //数据包特点
                data_character: {
                    thead: [
                        {
                            title: "<b class='color-yellow mrg-r-1'>·</b>商圈综合画像",
                            grow: 1
                        },
                        {
                            title: "<div class='alpha-d6 fsize-d9'>商圈画像由商圈地理位置的周边配套画像与商圈人群结构和消费类型画像进行综合评估。</div>",
                            grow: 2
                        }
                    ],
                    tbody: [
                        ["<b class='color-yellow mrg-r-1'>·</b>商圈人口热度分时测算", "<div class='alpha-d6 fsize-d9'>商圈人口热度数据来源于清华DaaS实时人口测算接口，支持对目标区域进行小时级别的测算。</div>"],
                        ["<b class='color-yellow mrg-r-1'>·</b>消费轨迹与消费类别", "<div class='alpha-d6 fsize-d9'>商圈人群画像数据支持对区域内人员消费轨迹、以及人员消费类别进行分析。</div>"],
                        ["<b class='color-yellow mrg-r-1'>·</b>商圈优劣势对比", "<div class='alpha-d6 fsize-d9'>支持在多个目标商圈间进行多维度对比。</div>"]
                    ],
                    colors: {
                        thead: "neutral",
                        row: {
                            head: "none",
                            odd: "rgba(134,134,134,.4)",
                            even: "neutral"
                        },
                        line: "none",
                        outline: "none"
                    }
                },

                //数据内容
                data_cont: {
                    val: "rk",
                    tagsData: {
                        tagList: [
                            {
                                id: "rk",
                                text: "人口画像与配套画像",
                                desc: "地理范围：目标城市及商圈 更新频率：按天/周/月更新",
                                text_list: [
                                    "商圈人口的居住/商业类型分布",
                                    "商圈的楼宇、商业体、小区的房价与租金",
                                    "商圈人口的年龄构成",
                                    "商圈周边的配套设施数量",
                                    "商圈的交通拥堵情况",
                                    "商圈周边的公共交通配套",
                                    "商圈人口的分布和流动",
                                    "商圈周边的生活配套",
                                    "商圈的消费等级",
                                    "商圈周边的酒店分布",
                                    "商圈消费者喜好",
                                    "商圈周边的餐饮场所分布",
                                    "商圈消费者的消费类别",
                                    "商圈周边的休闲场所分布",
                                    "商圈的消费者口碑",
                                    "商圈周边的企业类型构成",
                                    "商圈区域的人均可支配收入",
                                    "商圈所在城市的人口、产业、民生、交通、百姓口碑等各种宏观指标",
                                    "商圈指定区域的人口热度高频测算"
                                ]
                            }
                        ],
                        colors: {
                            normal: {
                                text: "rgba(255,255,255,.4)",
                                bg: "rgba(0,0,0,.5)",
                            },
                            act: {
                                text: "#ffcc00",
                                bg: "dgray",
                            },
                            hover: {
                                text: "mgray",
                                bg: "rgba(0,0,0,.5)",
                            },
                        }
                    }
                },

                //底部信息
                footer_data: {
                    package: {
                        title: "商圈画像数据包",
                        packageId: name,
                        packageName: "所有与商圈评估规划相关的问题",
                        matteData: bg
                    }
                }

            }
        }
    }
</script>


// WEBPACK FOOTER //
// src/router/cbd.vue